<!--
  @Description: 直播频道
  @Author: wang.y 
  @Date: 2022-05-27 
-->
<template>
  <div class="live-index">
    <Spin v-if="loading" class="comp-spin" fix>
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="live">
      <div class="live-top">
        <div class="live-banner">
          <!-- banner -->
          <Banner :banner1="banner1" :banner4="banner4" :banner5="banner5" :live="1"></Banner>
        </div>
        <div class="live-notice">
          <div :class="{'live-top':noticelist.length > 0, 'replay-top':noticelist.length == 0 }"></div>
          <div class="live-notice-content live-content" v-if="noticelist.length > 0">
            <div class="notice-li" v-for="item,index in noticelist">
              <div class="notice-time">{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
              <a class="notice-name" @click="getliveurl(item)">{{item.title}}</a>
            </div>
          </div>
          <div class="live-notice-content replay-content" v-else>
            <div class="replay-li" v-for="item,index in livelist2.slice(0,4)">
              <a class="replay-name" @click="getliveurl(item)">{{item.title}}</a>
              <div class="replay-time">{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="list-container" v-if="livelist1.length">
        <div class="list-name">
          <div class="list-name-l">即将开播</div>
          <div class="name-line"></div>
          <!-- <a class="list-more" :href="$store.state.index_path + '/liveList?listtype=1'" target="_blank">查看更多</a> -->
        </div>
        <div class="list">
          <div class="list-item" v-for="item,index in livelist1" :key="index">
            <div class="list-item-img" @click="getliveurl(item)">
              <div class="list-item-status on" v-if="item.aliveState == 0">
                <i class="iconfont">&#xe6c5;</i>距直播还有 {{diffTime(item.aliveStartAt)}}
              </div>
              <div class="list-item-status on" v-if="item.aliveState == 1">
                <i class="iconfont">&#xe6c3;</i>正在直播
              </div>
              <div class="live-icon">
                <i class="iconfont">&#xe6c6;</i>
              </div>
              <img :src="item.imgUrl">
            </div>
            <div class="list-item-time on" v-if="item.aliveState == 0">直播时间丨{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
            <div class="list-item-time on" v-if="item.aliveState == 1">正在直播丨{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
            <a class="list-item-name" @click="getliveurl(item)">{{item.title}}</a>
          </div>
        </div>
      </div>
      <div class="list-container">
        <div class="list-name">
          <div class="list-name-l">精彩回放</div>
          <div class="name-line"></div>
          <!-- <a class="list-more" :href="$store.state.index_path + '/liveList?listtype=2'" target="_blank">查看更多</a> -->
        </div>
        <div class="list">
          <div class="list-item list-item2" v-for="item,index in livelist2" :key="index">
            <div class="list-item-img" @click="getliveurl(item)">
              <div class="list-item-status">
                <i class="iconfont">&#xe6c4;</i>直播回放
              </div>
              <div class="live-icon">
                <i class="iconfont">&#xe6c6;</i>
              </div>
              <img :src="item.imgUrl">
            </div>
            <div class="list-item-time">直播回放丨{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
            <a class="list-item-name" @click="getliveurl(item)">{{item.title}}</a>
          </div>
        </div>
        <div class="more_div" v-if="more_loading2"><Button :loading="more_loading2" class="more_loading">加载中</Button></div>
      </div>
      <!-- <div class="list-container">
        <div class="list-name">
          <div class="list-name-l">相关文章</div>
          <div class="name-line"></div>
        </div>
        <div class="art-list">
          <div class="list-item" v-for="item,index in articleList">
            <div class="list-item-img">
              <a :href="$store.state.index2_path + '/' + item.id" target="_blank">
                <img :src="item.logoPath | logo_show" />
              </a>
            </div>
            <div class="list-item-cnt">
              <a class="title" :href="$store.state.index2_path + '/' + item.id" target="_blank">{{item.title}}</a>
              <div class="info">
                <div class="time">{{item.publishTime | time_standard}}</div>
                <div class="author">
                  <img class="author-img" :src="item.authorLogoPath | logo_show('', $store.state.static_img_url + 'pic/vcbeat/no_face.jpg')">
                  {{item.authorName}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more_div" v-if="is_more"><Button @click="more()" :loading="more_loading" :class="more_loading ? 'more_loading' : ''">{{more_loading ? '加载中' : '加载更多'}}</Button></div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { getBanner, liveList, onlinearticlelist } from '@/service'
import Banner from './components/Banner'
import moment from 'moment'
export default {
  metaInfo() {
    return {
      title: '直播频道-动脉网',
    }
  },
  inject: ['login'],
  components: {
    Banner,
  },
  created() {
    Promise.all([
      new Promise((resolve) => {
        this.getBanner(resolve)
      }),
      new Promise((resolve) => {
        this.getLiveList(resolve)
      }),
    ]).then((res) => {
      this.loading = false
    })
  },
  mounted() {
    this.liveInterval = setInterval(() => {
      this.now_time = moment().unix()
    }, 1000)

    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollTop > (scrollHeight - windowHeight - 300) && !this.more_loading2 && scrollTop > 0 && this.is_more2) {
          ++this.follow_page
          this.morelist()
        }
      })
    })
  },
  beforeDestroy() {
    clearInterval(this.liveInterval)
    this.liveInterval = ''
    window.onscroll = ''
  },
  data() {
    return {
      banner1: [],
      banner4: {},
      banner5: {},
      loading: true,
      more_loading: true,
      more_loading2: false,
      params: {
        page: 1,
        size: 16,
      },
      articleList: [],
      is_more: true,
      is_more2: true,

      livelist1: [],
      livelist2: [],
      noticelist: [],

      now_time: '',
      liveInterval: '',

      page2: 1,
    }
  },
  computed: {
    diffTime() {
      let fm = (num) => (num < 10 ? '0' + num : num)
      return function (t) {
        let str = moment(t).unix() - this.now_time
        let h = Math.floor(str / 3600),
          d = Math.floor(h / 24),
          h2 = Math.floor(h % 24),
          m = Math.floor((str % 3600) / 60),
          s = (str % 3600) % 60
        let hh = fm(h2),
          mm = fm(m),
          ss = fm(s)
        let dd = d >= 1 ? d + '天' : ''
        return dd + hh + '时' + mm + '分' + ss + '秒'
      }
    },
    user_key() {
      return this.$store.state.user_key
    },
  },
  methods: {
    /**
     * @description: 广告位
     * @param {*}
     * @return {*}
     */
    async getBanner(resolve) {
      let res = await getBanner(
        {
          position_id: ['59', '60', '61', '62', '63', '64', '65'],
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      resolve(res)
      if (res.code == 0) {
        res.data.forEach((item) => {
          if (
            item.posId == '59' ||
            item.posId == '60' ||
            item.posId == '61' ||
            item.posId == '62' ||
            item.posId == '63'
          ) {
            this.banner1.push(item)
          } else if (item.posId == '64') {
            this.banner4 = item
          } else if (item.posId == '65') {
            this.banner5 = item
          }
        })
        this.banner_loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * @description: 文章列表
     * @param {*}
     * @return {*}
     */
    async indexlist(resolve) {
      this.more_loading = true
      let res = await onlinearticlelist(
        { ...this.params, ...{ user_key: this.$store.state.user_key } },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (resolve) resolve(res)
      this.more_loading = false
      if (res.code == 0) {
        if (this.params.page == 1) {
          this.articleList = [...res.data.topList, ...res.data.list]
        } else {
          this.articleList = [...this.articleList, ...res.data.list]
        }
        this.is_more = res.data.list.length == this.params.size
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * @description: 加载更多
     * @param {*}
     * @return {*}
     */
    more() {
      ++this.params.page
      this.indexlist()
    },
    async getLiveList(resolve) {
      // 最新直播列表
      let res = await liveList(
        {
          page: 1,
          pageSize: 24,
          scene: 1,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )

      // 回看列表
      let res2 = await liveList(
        {
          page: 1,
          pageSize: 9,
          scene: 2,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )

      // 预告
      let res3 = await liveList(
        {
          pageSize: 10,
          scene: 3,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      resolve({
        res: res,
        res2: res2,
        res3: res3,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'livelist1', res.data.list)
      } else {
        this.$Message.error(res.msg)
      }
      if (res2.code == 0) {
        this.$set(this.$data, 'livelist2', res2.data.list)
      } else {
        this.$Message.error(res2.msg)
      }
      if (res3.code == 0) {
        this.$set(this.$data, 'noticelist', res3.data.list)
      } else {
        this.$Message.error(res3.msg)
      }
    },
    getliveurl(item) {
      window.open(item.h5Url)
    },
    async morelist() {
      ++this.page2
      this.more_loading2 = true
      let res = await liveList(
        {
          page: this.page2,
          pageSize: 9,
          scene: 2,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.more_loading2 = false
      if (res.code == 0) {
        this.livelist2 = [...this.livelist2, ...res.data.list]
        this.is_more2 = this.page2 < Math.ceil(res.data.total / 9)
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * @description: 滚动条防抖
     * @param {*} fn
     * @param {*} wait
     * @return {*}
     */    
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common.stylus'
.live-index
  background #fff
  position relative
  >>>.ivu-spin
    color #FF8824
    &.comp-spin
      z-index 10
      .ivu-spin-main
        top 42vh
  .live
    position relative
    width 1140px
    min-height calc(100vh - 64px)
    margin 0 auto
    padding 30px 0
    .live-top
      display flex
      .live-banner
        width 820px
        margin-right 20px
      .live-notice
        width 300px
        .live-top
          height 60px
          background url('~pic/notice-bg.png') #FCFCFC no-repeat
        .replay-top
          height 60px
          background url('~pic/replay-bg.png') #FCFCFC no-repeat
          background-size 100%
        &-content
          border-top 0
          overflow auto
          height 280px
          background #FCFCFC
        .replay-content
          border 1px solid #FFE8D5
          padding 16px 20px 0
          .replay-li
            border-left 1px solid #FF8824
            .replay-name
              font-size 13px
              color #333333
              line-height 18px !important
              padding-left 10px
              ellipsisClamp2()
              text-align justify
              position relative
              &::before
                content ''
                width 4px
                height 16px
                background #FF8824
                position absolute
                left 0
                top 0
              &:hover
                color #ff8824
            .replay-time
              font-size 12px
              font-weight 500
              color #999999
              padding-top 2px
              padding-left 10px
              padding-bottom 9px
              line-height 1.5 !important
        .live-content
          border 1px solid #018CF1
          padding 14px 18px
          .notice-li
            font-size 0
            .notice-time
              font-size 12px
              color #FFFFFF
              line-height 16px
              padding 0 6px
              background linear-gradient(90deg, #0168EC, #00A2F5)
              display inline-block
              vertical-align middle
            a.notice-name
              display block
              border-left 1px solid #AAD0FF
              font-size 13px
              color #333333
              line-height 18px
              padding 10px 0 10px 10px
              &:hover
                color #ff8824
    .list-container
      margin-top 30px
      .list-name
        display flex
        align-items center
        &-l
          font-size 24px
          font-weight bold
          color #333333
          margin-right 20px
          line-height 28px
        .name-line
          flex 1
          height 1px
          background #EEEEEE
        a.list-more
          width 96px
          height 28px
          background #FF8824
          color #FFFFFF
          display flex
          justify-content center
          align-items center
          margin-left 20px
          cursor pointer
          transition all 0.2s
          &:hover
            background #f60
      .list
        display flex
        padding-top 30px
        flex-wrap wrap
        .list-item
          width 360px
          margin-bottom 30px
          margin-right 30px
          &:nth-of-type(3n)
            margin-right 0
          .list-item-img
            height 216px
            position relative
            overflow hidden
            cursor pointer
            img
              width 100%
              height 100%
              transition all 0.3s
            &:hover
              img
                transform scale(1.1, 1.1)
            .list-item-status
              position absolute
              background #0177EE
              font-size 13px
              display flex
              align-items center
              height 28px
              color #fff
              padding 0 6px
              z-index 2
              &.on
                background #ff8824
              i
                font-size 13px
                margin-right 5px
            .live-icon
              position absolute
              top 50%
              left 50%
              transform translate(-50%, -50%)
              z-index 2
              width 70px
              height 70px
              background rgba(0, 0, 0, 0.6)
              border-radius 50%
              display flex
              align-items center
              justify-content center
              .iconfont
                font-size 28px
                color #fff
          .list-item-time
            margin-top 14px
            line-height 20px
            background #E9F3FF
            color #0177EE
            display inline-block
            vertical-align middle
            padding 0 6px
            &.on
              background-color #FFEFE2
              color #ff8824
          a.list-item-name
            margin-top 14px
            font-size 18px
            font-weight bold
            color #333333
            line-height 28px
            cursor pointer
            display -webkit-box
            overflow hidden
            text-overflow ellipsis
            word-break break-all
            -webkit-box-orient vertical
            -webkit-line-clamp 2
            &:hover
              color #ff8824
        .list-item2
          .list-item-img
            .list-item-status
              background rgba(0, 0, 0, 0.6)
          .list-item-time
            padding 0
            color #666
            background none
            line-height 1
      .art-list
        display flex
        flex-wrap wrap
        .list-item
          width 262px
          margin-right 30px
          margin-top 30px
          box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
          &:nth-of-type(4n)
            margin-right 0
          .list-item-img
            height 164px
            overflow hidden
            img
              width 100%
              height 100%
              transition all 0.3s
              cursor pointer
              &:hover
                transform scale(1.1, 1.1)
          .list-item-cnt
            padding 20px
            a.title
              font-weight bold
              color #333333
              line-height 20px
              font-size 14px
              height 40px
              cursor pointer
              display -webkit-box
              overflow hidden
              text-overflow ellipsis
              word-break break-all
              -webkit-box-orient vertical
              -webkit-line-clamp 2
              &:hover
                color #ff8824
            .info
              display flex
              align-items center
              justify-content space-between
              margin-top 20px
              .time
                color #999999
                font-size 12px
              .author
                display flex
                align-items center
                font-size 12px
                color #ff8824
                .author-img
                  width 24px
                  height 24px
                  border-radius 50%
                  margin-right 6px
      .more_div
        text-align center
        padding-top 30px
        button
          color #ff8824
          border 1px solid #ff8824
          width 126px
          height 38px
          background-color #fff
          cursor pointer
          border-radius 20px
          &:focus
            box-shadow none
        .more_loading
          border 0
</style>